module.exports = __webpack_public_path__ + "mobile/img/crm-banner.db605642.png";